<template>
  <div class="history-page app-page">
    <header class="app-page-header">
      <h1 class="page-title">历史记录</h1>
    </header>

    <div class="filter-bar">
      <select v-model="filterType" class="filter-sel">
        <option value="">全部</option>
        <option value="quick_video">视频</option>
        <option value="quick_image">图片</option>
      </select>
      <span class="total-hint">{{ totalCount }} 条对话</span>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="state-hint">加载中…</div>

    <!-- 空状态 -->
    <div v-else-if="!items.length && !loading" class="state-hint empty">
      暂无创作记录，<button type="button" class="link-btn" @click="$router.push('/create').catch(()=>{})">去创作 →</button>
    </div>

    <!-- 列表 -->
    <div v-else class="conv-list">
      <div
        v-for="item in items"
        :key="item.id"
        class="conv-item"
        :class="{ 'conv-item--video': item.type === 'quick_video', 'conv-item--image': item.type === 'quick_image' }"
      >
        <div class="conv-icon" v-html="typeIcon(item.type)" />
        <div class="conv-body">
          <div class="conv-title" :title="item.title">{{ item.title || '无标题' }}</div>
          <div class="conv-meta">
            <span class="type-badge">{{ item.type === 'quick_video' ? '视频' : '图片' }}</span>
            <span class="conv-time">{{ formatDateTime(item.createtime) }}</span>
          </div>
        </div>
        <div class="conv-actions">
          <button type="button" class="act-btn act-btn--go" @click="goToConversation(item)">
            查看
          </button>
          <button type="button" class="act-btn act-btn--del" @click="confirmDelete(item)">
            删除
          </button>
        </div>
      </div>
    </div>

    <!-- 加载更多 -->
    <div v-if="hasMore && !loading" class="load-more">
      <button type="button" class="load-more-btn" @click="loadMore">加载更多</button>
    </div>
    <div v-if="loadingMore" class="state-hint">加载中…</div>

    <!-- 删除确认 -->
    <div v-if="deleteTarget" class="mask" @click.self="deleteTarget = null">
      <div class="confirm-dialog">
        <p>确认删除「{{ deleteTarget.title }}」？</p>
        <div class="confirm-ft">
          <button type="button" @click="deleteTarget = null">取消</button>
          <button type="button" class="danger" :disabled="deleting" @click="doDelete">
            {{ deleting ? '删除中…' : '删除' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userApi } from "../api/user";

export default {
  name: "HistoryPage",
  data() {
    return {
      items: [],
      loading: false,
      loadingMore: false,
      page: 1,
      pageSize: 20,
      hasMore: true,
      totalCount: 0,
      filterType: "",
      deleteTarget: null,
      deleting: false
    };
  },
  watch: {
    filterType() {
      this.load(true);
    }
  },
  async mounted() {
    await this.load(true);
  },
  methods: {
    typeIcon(type) {
      const svg = (body) =>
        `<svg class="conv-icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">${body}</svg>`;
      if (type === "quick_video") {
        return svg(
          '<rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.8"/><path d="M10 10.5v5l5.5-2.5L10 10.5z" fill="currentColor"/>'
        );
      }
      if (type === "quick_image") {
        return svg(
          '<rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.8"/><circle cx="8.5" cy="10" r="1.5" fill="currentColor"/><path d="M21 17l-6-6-4 4-3-3-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>'
        );
      }
      return svg('<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/>');
    },
    formatDateTime(ts) {
      if (!ts) return "—";
      const d = new Date(Number(ts) * 1000);
      return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
    },
    async load(reset) {
      if (reset) {
        this.page = 1;
        this.hasMore = true;
        this.items = [];
        this.loading = true;
      } else if (!this.hasMore || this.loadingMore) return;
      else this.loadingMore = true;
      try {
        const res = await userApi.conversations({
          type: this.filterType || undefined,
          page: this.page,
          pageSize: this.pageSize
        });
        const items = (res && res.items) || (Array.isArray(res) ? res : []);
        this.totalCount = (res && res.totalCount) || (Array.isArray(res) ? res.length : 0);
        if (reset) this.items = items;
        else this.items = [...this.items, ...items];
        this.hasMore = !!(res && res.hasMore);
        if (this.hasMore) this.page += 1;
      } catch (e) {
        this.items = [];
      } finally {
        this.loading = false;
        this.loadingMore = false;
      }
    },
    loadMore() {
      this.load(false);
    },
    goToConversation(item) {
      const path = item.type === "quick_video" ? "/quick-video?id=" + item.id : "/quick-image?id=" + item.id;
      this.$router.push(path).catch(() => {});
    },
    confirmDelete(item) {
      this.deleteTarget = item;
    },
    async doDelete() {
      if (!this.deleteTarget) return;
      this.deleting = true;
      try {
        await userApi.deleteConversation({ id: this.deleteTarget.id });
        this.items = this.items.filter(x => x.id !== this.deleteTarget.id);
        this.totalCount = Math.max(0, this.totalCount - 1);
        this.deleteTarget = null;
      } catch (e) {
        window.alert((e && e.message) || "删除失败");
      } finally {
        this.deleting = false;
      }
    }
  }
};
</script>

<style scoped>
.history-page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 20px);
  background: #333333;
  padding: 0 16px 16px;
}
.app-page-header {
  padding: 14px 0 6px;
  flex-shrink: 0;
}
.page-title {
  margin: 0;
  font-size: 20px;
  color: #e9e9e9;
}
.filter-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0 14px;
  flex-shrink: 0;
}
.filter-sel {
  height: 32px;
  background: #1f1f1f;
  border: 1px solid #3a3a3a;
  border-radius: 8px;
  color: #e9e9e9;
  font-size: 13px;
  padding: 0 10px;
  cursor: pointer;
}
.total-hint {
  font-size: 13px;
  color: #9ca3af;
  margin-left: auto;
}
.state-hint {
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
  padding: 40px 0;
}
.state-hint.empty {
  color: #6b7280;
}
.link-btn {
  background: none;
  border: none;
  color: #19b06b;
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
}
.conv-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.conv-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #1f1f1f;
  border-radius: 10px;
  transition: background 0.12s;
}
.conv-item:hover {
  background: #242424;
}
.conv-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2a2a2a;
  border-radius: 8px;
}
.conv-icon :deep(.conv-icon-svg) {
  width: 18px;
  height: 18px;
}
.conv-body {
  flex: 1;
  min-width: 0;
}
.conv-title {
  font-size: 14px;
  color: #e9e9e9;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 4px;
}
.conv-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}
.type-badge {
  font-size: 14px;
  background: #2a3a2a;
  color: #19b06b;
  padding: 1px 6px;
  border-radius: 4px;
}
.conv-item--image .type-badge {
  background: #2a2a3a;
  color: #6b8afd;
}
.conv-time {
  font-size: 14px;
  color: #6b7280;
}
.conv-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}
.act-btn {
  height: 28px;
  padding: 0 10px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.12s;
}
.act-btn--go {
  background: #19b06b;
  color: #fff;
}
.act-btn--go:hover {
  background: #17a062;
}
.act-btn--del {
  background: #2a2a2a;
  color: #9ca3af;
  border: 1px solid #3a3a3a;
}
.act-btn--del:hover {
  background: #773131;
  color: #fff;
  border-color: #773131;
}
.load-more {
  flex-shrink: 0;
  text-align: center;
  padding: 14px 0;
}
.load-more-btn {
  height: 36px;
  padding: 0 24px;
  background: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 8px;
  color: #9ca3af;
  font-size: 13px;
  cursor: pointer;
}
.load-more-btn:hover {
  background: #333;
  color: #e9e9e9;
}
.mask {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirm-dialog {
  background: #2a2a2a;
  border: 1px solid #444;
  border-radius: 12px;
  padding: 20px;
  width: 300px;
  font-size: 14px;
  color: #e9e9e9;
}
.confirm-dialog p {
  margin: 0 0 16px;
  line-height: 1.5;
}
.confirm-ft {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.confirm-ft button {
  height: 32px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  background: #3a3a3a;
  color: #e9e9e9;
}
.confirm-ft button.danger {
  background: #773131;
  color: #fff;
}
.confirm-ft button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
